<template>
  <div class="account-wrap">
    <div class="header group">
      <div class="header-menu pure-menu pure-menu-horizontal group">
        <router-link to="/" class="pure-menu-heading home-link" v-on:click.native="homeClick()"><i class="fal fa-home"></i> Matrix</router-link>
        <ul class="pure-menu-list main-menu">
          <li class="pure-menu-item pure-menu-has-children pure-menu-allow-hover account-menu-item"><a href="#" v-on:click.stop.prevent="menuOpenClick" class="pure-menu-link"><i class="fas fa-bars"></i></a>
            <ul class="pure-menu-children">
              <li class="pure-menu-item"><router-link to="/lists" class="pure-menu-link">Lists</router-link></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div id="account-detail-wrap" class="" v-if="isLoggedIn">

      <div class="tab-back" v-on:click="closeAccountTab()"><i class="fas fa-arrow-left"></i></div>

      <div class="tab">
        <button class="tablinks active" data-name="account" v-on:click="openAccountTab('account')">Account</button>
        <button class="tablinks hidden" data-name="newsletter" v-on:click="openAccountTab('newsletter')">Newsletter</button>
        <button class="tablinks hidden" data-name="notifications" v-on:click="openAccountTab('notifications')">Notifications</button>
      </div>

      <div id="account" data-name="account" class="tabcontent" style="display: block;">
        <div class="user-details">
          <h3>Your account</h3>
          <img :src="photo" style='height: 84px'> <br>
          <p v-if="username"><span>Username:</span> {{username}}</p>
          <p><span>Email:</span> {{email}}</p>
          <div id="username-select">
            <form v-on:submit.prevent="updateUsername" novalidate class="pure-form pure-form-stacked">
              <input type="text" class="input" :placeholder="usernameHeading" v-model="newUsername" maxlength="15" v-on:keyup="checkUsername">
              <button class="button is-primary pure-button" :disabled="(!usernameAvailable || !newUsername) || usernameInvalid" type="submit" name="action" v-on:click.stop.prevent="updateUsername">Apply</button>
            </form>
            <p class="help is-success" v-if="usernameAvailable && newUsername && !usernameInvalid">
              {{newUsername}} is available
            </p>
            <p class="help is-danger" v-if="!usernameAvailable && newUsername && !newUsernameSet">
              {{newUsername}} has already been taken
            </p>
            <p class="help is-danger" v-if="usernameInvalid && newUsername">
              Username must only contain alphanumeric characters
            </p>
            <p class="help is-success" v-if="newUsernameSet">
              Your new username has been set
            </p>
          </div>
          <button class="pure-button username-set-toggle" v-on:click="changeUsernameToggle()">Change username</button>
          <button id="btnLogout" v-on:click="logOut()" class="pure-button">
            Log out
          </button>
        </div>
      </div>

      <div id="newsletter" data-name="newsletter" class="tabcontent hidden" style="display: none;">
        <div id="newsletter-prefs">
          <h3>Newsletter</h3>
          <p>Would you like to receive any of our emails?</p>
          <form class="pure-form newsletter-prefs-form" v-on:submit.prevent="savePrefs">
            <label for="option-one" class="pure-radio">
                1 grape a day
                <input id="option-one" type="radio" name="optionsRadios" value="130f947659" :checked="'130f947659' == currentSubscriptionOption">
                <span class="checkmark"></span>
            </label>

            <label for="option-two" class="pure-radio">
                3 grapes a day
                <input id="option-two" type="radio" name="optionsRadios" value="cd6df375ee" :checked="'cd6df375ee' == currentSubscriptionOption">
                <span class="checkmark"></span>
            </label>

            <label for="option-three" class="pure-radio">
                7 grapes, once a week
                <input id="option-three" type="radio" name="optionsRadios" value="7b88dc884a" :checked="'7b88dc884a' == currentSubscriptionOption">
                <span class="checkmark"></span>
            </label>

            <label for="option-four" class="pure-radio">
                No newsletter
                <input id="option-four" type="radio" name="optionsRadios" value="926d562b52" :checked="'926d562b52' == currentSubscriptionOption">
                <span class="checkmark"></span>
            </label>

            <button id="btnSavePrefs" v-on:click="savePrefs()" class="pure-button">
              Save preferences
            </button>
            <button id="btnPrivacyPolicy" v-on:click="goPrivacyPolicy()" class="pure-button">
              Privacy Policy
            </button>
            <div class="add-trigger" v-bind:class="{ drawn: hasSaved }"></div>
            <svg version="1.1" id="tick" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               viewBox="0 0 37 37" style="enable-background:new 0 0 37 37;" xml:space="preserve">
            <path class="circ path" style="fill:none;stroke:#1d8019;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;" d="
              M30.5,6.5L30.5,6.5c6.6,6.6,6.6,17.4,0,24l0,0c-6.6,6.6-17.4,6.6-24,0l0,0c-6.6-6.6-6.6-17.4,0-24l0,0C13.1-0.2,23.9-0.2,30.5,6.5z"
              />
            <polyline class="tick path" style="fill:none;stroke:#1d8019;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;" points="
              11.6,20 15.9,24.2 26.4,13.8 "/>
            </svg>
          </form>
        </div>
      </div>

      <div id="notifications" data-name="notifications" class="tabcontent hidden" style="display: none;">
        <div id="notification-prefs">
          <h3>Notifications</h3>
          <p>What would you like to be notified about?</p>
          <form class="pure-form newsletter-prefs-form notification-prefs-form" v-on:submit.prevent="saveNotificationPrefs">
            <label for="notification-rated" class="pure-radio">
                Your grape has been rated
                <input id="notification-rated" type="checkbox" name="notification-rated" value="rated" :checked="notificationGrapeRated" v-model="notificationGrapeRated">
                <span class="checkmark"></span>
            </label>

            <label for="notification-vined" class="pure-radio">
                Your grape has been vined
                <input id="notification-vined" type="checkbox" name="notification-vined" value="vined" :checked="notificationGrapeVined" v-model="notificationGrapeVined">
                <span class="checkmark"></span>
            </label>

            <label for="notification-grapevine-follow" class="pure-radio">
                A grape has been added to a grapevine you follow
                <input id="notification-grapevine-follow" type="checkbox" name="notification-grapevine-follow" value="grapevine-follow" :checked="notificationGrapeAddedToFollowed" v-model="notificationGrapeAddedToFollowed">
                <span class="checkmark"></span>
            </label>

            <button id="btnSavePrefs" v-on:click="saveNotificationPrefs()" class="pure-button">
              Save preferences
            </button>
            <div class="add-trigger" v-bind:class="{ drawn: notificationsHasSaved }"></div>
            <svg version="1.1" id="tick" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               viewBox="0 0 37 37" style="enable-background:new 0 0 37 37;" xml:space="preserve">
            <path class="circ path" style="fill:none;stroke:#1d8019;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;" d="
              M30.5,6.5L30.5,6.5c6.6,6.6,6.6,17.4,0,24l0,0c-6.6,6.6-17.4,6.6-24,0l0,0c-6.6-6.6-6.6-17.4,0-24l0,0C13.1-0.2,23.9-0.2,30.5,6.5z"
              />
            <polyline class="tick path" style="fill:none;stroke:#1d8019;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;" points="
              11.6,20 15.9,24.2 26.4,13.8 "/>
            </svg>

          </form>
        </div>
      </div>

    </div>

    <div id="login-signup-wrap" v-if="!isLoggedIn">
      <div class="pure-g">
        <div class="login pure-form pure-form-stacked pure-u-1">
          <button v-on:click="googleLogin()" class="pure-button loginBtn loginBtn--google">
            Login with Google
          </button>
          <button v-on:click="facebookLogin()" class="pure-button loginBtn loginBtn--facebook">
            Login with Facebook
          </button>
          <button v-on:click="grapevineLogin()" class="pure-button loginBtn loginBtn--grapevine">
            Login with Matrix
          </button>
          <p class="notice">{{notice}}</p>
          <div class="grapevine-login-wrap">
            <input type="text" v-model="loginEmail" placeholder="Email">
            <input type="password" v-model="loginPassword" placeholder="Password">
            <button id="btnLogin" v-on:click="login()" class="pure-button">
              Log in
            </button>
          </div>
        </div>
        <hr />
        <div class="sign-up pure-form pure-form-stacked pure-u-1">
          <button class="pure-button create-account-button" v-on:click="showCreateAccount()">Create Account</button>
          <div class="create-account-wrap">
            <p class="notice">{{signupNotice}}</p>
            <input type="text" v-model="email" placeholder="Email" />
            <input type="password" v-model="password" placeholder="Password" />
            <input type="password" v-model="confirmPassword" placeholder="Confirm Password" />
            <button id="btnSignUp"v-on:click="signUp" class="pure-button">Sign Up</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* global mixpanel */
  import firebase from 'firebase'
  import Request from 'superagent'
  import MD5 from 'md5'
  import db from './firebaseInit'
  import Router from '../router'

  var googleProvider = new firebase.auth.GoogleAuthProvider()
  var facebookProvider = new firebase.auth.FacebookAuthProvider()
  export default {
    name: 'account',
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: 'Account'
    },
    data: function () {
      return {
        photo: '',
        userId: '',
        name: '',
        user: null,
        username: null,
        newUsername: null,
        usernameSet: false,
        usernameAvailable: true,
        usernameInvalid: false,
        newUsernameSet: false,
        email: '',
        password: '',
        confirmPassword: '',
        loginEmail: '',
        loginPassword: '',
        isLoggedIn: false,
        notice: '',
        signupNotice: '',
        socialLoginInProgress: false,
        usernameHeading: 'Choose a Username',
        currentSubscriptionOption: null,
        hasSaved: false,
        notificationGrapeRated: false,
        notificationGrapeVined: false,
        notificationGrapeAddedToFollowed: false,
        notificationsHasSaved: false,
      }
    },
    created () {
      mixpanel.track('Load account page')
      var vm = this
      firebase.auth().onAuthStateChanged(function (user) {
        vm.username = null
        if (user) {
          vm.isLoggedIn = true
          vm.user = user
          vm.name = vm.user.displayName
          vm.email = vm.user.email
          vm.photo = vm.user.photoURL
          vm.userId = vm.user.uid
          mixpanel.identify(vm.userId)
          mixpanel.people.set({
            '$last_login': new Date(),
            '$email': vm.email
          })
          vm.getSubscriberStatus()
          firebase.database().ref('users/' + user.uid).once('value', function (snapshot) {
            if (snapshot.val()) {
              vm.username = snapshot.val().username
              vm.notificationGrapeRated = snapshot.val().notificationGrapeRated
              vm.notificationGrapeVined = snapshot.val().notificationGrapeVined
              vm.notificationGrapeAddedToFollowed = snapshot.val().notificationGrapeAddedToFollowed

              if (vm.notificationGrapeRated == null) {
                vm.notificationGrapeRated = true
              }
              if (vm.notificationGrapeVined == null) {
                vm.notificationGrapeVined = true
              }
              if (vm.notificationGrapeAddedToFollowed == null) {
                vm.notificationGrapeAddedToFollowed = true
              }

              if (vm.username) {
                vm.usernameSet = true
                vm.usernameHeading = 'Change Username'
              } else {
                console.log('username not set')
                vm.createDefaultUsername(vm.email)
              }
            } else {
              console.log('username not set')
              vm.createDefaultUsername(vm.email)
            }
          })
          mixpanel.people.set({
            'username': vm.user.displayName,
            '$last_login': new Date(),
            '$email': vm.email
          })
        }
      })
    },
    methods: {
      homeClick: function () {
        this.$eventHub.$emit('navigate-home')
      },
      menuOpenClick: function () {

      },
      openAccountTab: function(tabName) {
        // Declare all variables
        var i, tabcontent, tablinks;

        // Get all elements with class="tabcontent" and hide them
        tabcontent = document.getElementsByClassName("tabcontent");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
        }

        // Get all elements with class="tablinks" and remove the class "active"
        tablinks = document.getElementsByClassName("tablinks");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
        }

        // Show the current tab, and add an "active" class to the link that opened the tab
        document.getElementById(tabName).style.display = "block";
        $('.tabcontent').removeClass('active');
        $('.tablinks').removeClass('active');
        $('.tabcontent[data-name="' + tabName + '"]').addClass('active');
        $('.tablinks[data-name="' + tabName + '"]').addClass('active');
        $('#account-detail-wrap').addClass('has-tab-active');
      },
      closeAccountTab: function(tabName) {
        $('#account-detail-wrap').removeClass('has-tab-active');
        $('.tabcontent').removeClass('active');
      },
      login: function (event) {
        const email = this.loginEmail
        const pass = this.loginPassword
        const auth = firebase.auth()
        const promise = auth.signInWithEmailAndPassword(email, pass)
        this.loginEmail = ''
        this.loginPassword = ''
        event.message = event.message.replace('The user may have been deleted.', '')
        promise.catch(event => this.notice = event.message)
      },
      signUp: function (event) {
        let vm = this
        const email = this.email
        const pass = this.password
        const confirmPass = this.confirmPassword
        const auth = firebase.auth()
        if (pass === confirmPass) {
          const promise = auth.createUserWithEmailAndPassword(email, pass)
          this.email = ''
          this.password = ''
          promise.catch(event => this.signupNotice = event.message)
        } else {
          console.log('passwords do not match')
        }
      },
      googleLogin: function () {
        let vm = this
        if (!vm.socialLoginInProgress) {
          vm.socialLoginInProgress = true
        }
        firebase.auth().signInWithPopup(googleProvider).then(function (result) {
          console.log(result)
          vm.socialLoginInProgress = false
        }).catch(function (error) {
          console.log(error)
          vm.notice = error.message
          vm.socialLoginInProgress = false
        })
      },
      facebookLogin: function () {
        let vm = this
        if (!vm.socialLoginInProgress) {
          vm.socialLoginInProgress = true
        }
        firebase.auth().signInWithPopup(facebookProvider).then(function (result) {
          console.log(result)
          vm.socialLoginInProgress = false
        }).catch(function (error) {
          console.log(error)
          vm.notice = error.message
          vm.socialLoginInProgress = false
        })
      },
      grapevineLogin: function () {
        $('.grapevine-login-wrap').slideToggle(600)
      },
      showCreateAccount: function () {
        $('.create-account-wrap').slideToggle(600)
      },
      logOut: function () {
        this.$eventHub.$emit('user-logged-out')
        firebase.auth().signOut()
        this.isLoggedIn = false
      },
      createDefaultUsername: function (email) {
        let vm = this
        var username = email
        if (email.indexOf('@') >= 0) {
          username = email.substr(0, email.indexOf('@'))
        }
        username = username.toLowerCase()
        username = username.replace(/[^a-zA-Z0-9]/g, '')

        // check exists
        for (var i = 0; i < 10; i++) {
          (function (i) {
            setTimeout( function () {
              var newUsername = username
              if (i > 0) {
                newUsername = newUsername + i
              }
              vm.loopUsernames(newUsername)
            }, 1000 * i)
          })(i);
        }
      },
      loopUsernames: function (newUsername) {
        let vm = this
        if (!vm.usernameSet) {
          firebase.database().ref('usernames/' + newUsername).once('value', function (snapshot) {
            var exists = (snapshot.val() !== null)
            if (!exists && !vm.usernameSet) {
              let data = {}
              console.log('setting username to: ' + newUsername)
              data[newUsername] = vm.userId
              firebase.database().ref('users/' + vm.userId).update({'username': newUsername})
              firebase.database().ref('usernames/').update(data)
              vm.usernameSet = true
              vm.username = newUsername
              vm.changeSubscriberName()
              mixpanel.track(
                'Username updated',
                {
                  'username': newUsername
                }
              )
            }
          })
        }
      },
      validateUsername: function () {
        var username = this.newUsername.toLowerCase()
        var usernameRegxp = /^([a-zA-Z0-9_-]+)$/
        if (username.indexOf(' ') >= 0) {
          this.usernameInvalid = true
        } else if (usernameRegxp.test(username) === false) {
          this.usernameInvalid = true
        } else {
          this.usernameInvalid = false
        }
      },
      checkUsername: function () {
        this.newUsernameSet = false
        var username = this.newUsername.toLowerCase()
        var vm = this
        vm.validateUsername()
        if (!vm.usernameInvalid) {
          firebase.database().ref('usernames/' + username).once('value', function (snapshot) {
            var exists = (snapshot.val() !== null)
            vm.usernameAvailable = !exists
          })
        }
      },
      updateUsername: function () {
        this.checkUsername()
        var username = this.newUsername.toLowerCase()
        if (!this.usernameInvalid && this.usernameAvailable) {
          let data = {}
          data[username] = this.userId
          firebase.database().ref('users/' + this.userId).update({'username': username})
          firebase.database().ref('usernames/').update(data)
          this.processUsernameChange(this.username, username)
          this.usernameSet = true
          this.username = username
          mixpanel.track(
            'Username updated',
            {
              'username': username
            }
          )
        }
      },
      processUsernameChange: function (oldUsername, newUsername) {
        // Usernames table
        firebase.database().ref('usernames/' + oldUsername).remove()
        let data = {}
        data[newUsername] = this.userId
        firebase.database().ref('usernames/').update(data)

        // Users table
        firebase.database().ref('users/' + this.userId).update({'username': newUsername})

        // Update grapes

        this.$eventHub.$emit('username-changed')
        this.$globals.userUsername = newUsername
        this.newUsernameSet = true
        this.username = newUsername
        this.changeSubscriberName()
        setTimeout( function () {
          this.newUsernameSet = false
        }, 5000)
      },
      changeUsernameToggle: function () {
        $('#username-select').slideDown(400, function() {
          $('.username-set-toggle').toggle('slide')          
        });
      },
      userGrapes: function (newUsername) {
        var vm = this
        var grapesRef = db.collection('grapes').where('grapeUserID', '==', vm.userId)
        grapesRef.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var grapeData = doc.data()
            grapeData.docID = doc.id
            this.updateGrapeData(grapeData, newUsername)
          })
        })
      },
      updateGrapeData: function (grape, newUsername) {
        var grapeRef = db.collection('grapes').doc(grape.docID)
        var grapeID = grape.docID
        grapeRef.update({
          grapeUsername: newUsername
        })
        .then(function () {
          console.log('Document ' + grapeID + ' successfully updated username!')
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error updating document: ', error)
        })
      },
      savePrefs: function () {
        var $optionID = ''
        var radios = document.getElementsByName('optionsRadios');
        for (var i = 0, length = radios.length; i < length; i++) {
          if (radios[i].checked) {
            // do whatever you want with the checked radio
            $optionID = radios[i].value
            this.currentSubscriptionOption = $optionID
            this.updateSubscriberStatus($optionID)
            this.hasSaved = true
            setTimeout(function () {
              this.hasSaved = false
            }, 2000)
            // only one radio can be logically checked, don't check the rest
            break;
          }
        }
      },
      getSubscriberStatus: function () {
        console.log('getSubscriberStatus')
        let vm = this
        var userMD5 = vm.email.toLowerCase()
        userMD5 = MD5(userMD5)
        const req = Request
        .post('https://us-central1-grapevine-dc853.cloudfunctions.net/MailchimpGetSubscriberStatus')
        .query({ listID: '127371a51e' })
        .query({ userMD5: userMD5 })
        .then(function(res) {
          var obj = JSON.parse(res.body.text)
          console.log(obj)
          if (obj.status === "subscribed") {
            let interests = obj.interests
            vm.currentSubscriptionOption = Object.keys(interests).find(key => interests[key] === true)
            console.log('current sub opt: ' + vm.currentSubscriptionOption)
          } else {
            vm.addSubscriber()
          }
        })
      },
      addSubscriber: function () {
        let vm = this
        var email = vm.email.toLowerCase()
        const req = Request
        .post('https://us-central1-grapevine-dc853.cloudfunctions.net/MailchimpAddSubscriber')
        .query({ listID: '127371a51e' })
        .query({ email: email })
        .query({ optionID: '7b88dc884a' })
        .then(function(res) {
          var obj = JSON.parse(res.body.text)
          console.log(obj)
          if (obj.interests) {
            let interests = obj.interests
            vm.currentSubscriptionOption = Object.keys(interests).find(key => interests[key] === true)
          }
        })
      },
      changeSubscriberName: function () {
        let vm = this
        var userMD5 = vm.email.toLowerCase()
        var username = vm.username
        userMD5 = MD5(userMD5)
        const req = Request
        .post('https://us-central1-grapevine-dc853.cloudfunctions.net/MailchimpChangeSubscriberName')
        .query({ listID: '127371a51e' })
        .query({ userMD5: userMD5 })
        .query({ username: username })
        .then(function(res) {
          var obj = JSON.parse(res.body.text)
          console.log(res)
          console.log(obj)
        })
      },
      updateSubscriberStatus: function (optionID) {
        let vm = this
        var userMD5 = vm.email.toLowerCase()
        userMD5 = MD5(userMD5)
        const req = Request
        .post('https://us-central1-grapevine-dc853.cloudfunctions.net/MailchimpSetSubscriberStatus')
        .query({ listID: '127371a51e' })
        .query({ userMD5: userMD5 })
        .query({ optionID: optionID })
        .then(function(res) {
          var obj = JSON.parse(res.body.text)
          console.log(res)
          console.log(obj)
        })
      },
      saveNotificationPrefs: function () {
        // Users table
        let vm = this
        firebase.database().ref('users/' + vm.userId).update({
          'notificationGrapeRated' : vm.notificationGrapeRated,
          'notificationGrapeVined' : vm.notificationGrapeVined,
          'notificationGrapeAddedToFollowed' : vm.notificationGrapeAddedToFollowed
        }, function(error) {
          if (error) {
            // The write failed...
          } else {
            vm.notificationsHasSaved = true
            setTimeout(function () {
              vm.notificationsHasSaved = false
            }, 2000)
          }
        });
      },
      goPrivacyPolicy: function () {
        Router.push({name: 'privacy-policy'})
      }
    }
  };
</script>

<style>
  .circ {
    opacity: 0;
    stroke-dasharray: 130;
    stroke-dashoffset: 130;
    -webkit-transition: all 1s;
    -moz-transition: all 1s;
    -ms-transition: all 1s;
    -o-transition: all 1s;
    transition: all 1s;
  }
  .tick {
    stroke-dasharray: 50;
    stroke-dashoffset: 50;
    -webkit-transition: stroke-dashoffset 1s 0.5s ease-out;
    -moz-transition: stroke-dashoffset 1s 0.5s ease-out;
    -ms-transition: stroke-dashoffset 1s 0.5s ease-out;
    -o-transition: stroke-dashoffset 1s 0.5s ease-out;
    transition: stroke-dashoffset 1s 0.5s ease-out;
  }
  .newsletter-prefs-form .add-trigger.drawn + svg .path {
    opacity: 1;
    stroke-dashoffset: 0;
  }
  form svg#tick {
    width: 30px;
    height: 30px;
    margin: 24px 0 0 20px;
  }
</style>

<style lang="scss" scoped>
  .lists-wrap {
    padding-top: 0;
    width: 100%;
    max-width: 400px;
    text-align: left;
    margin: 0 auto;
    background: #EFF3F7;

    & > .section {
      background: #fff;
      padding: 15px;
      box-sizing: border-box;
      margin: 0 5px 5px;
    }
  }

  .header {
    margin: 5px;
  }

  .header-menu {
    background: rgb(41,100,134);
    background: -webkit-gradient(linear, left top, right top, from(rgba(41,100,134,1)), to(rgba(49,129,174,1)));
    background: linear-gradient(90deg, rgba(41,100,134,1) 0%, rgba(49,129,174,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#296486",endColorstr="#3181ae",GradientType=1);
    color: #fff;
    box-sizing: border-box;
    
    .pure-menu-heading {
      color: #fff;
      padding: 15px;
      font-size: 20px;
      float: left;
      text-transform: none;
      font-weight: bold;

      i {
        font-weight: normal;
        margin-right: 10px;
      }
    }
    .pure-menu-list {
      float: right;
      margin: 5px;
    }
    .pure-menu-list > .pure-menu-link {
      color: #fff;
      padding: 10px 18px;
      font-size: 20px;
    }
    .pure-menu-list .pure-menu-link:hover {
      color: #296486;
      background-color: #fff;
    }
  } /* end .header-menu */

  .create-account-wrap {
    display: none;
  }

  .create-account-button {
    width: 100%;
    background: #296486;
    color: #fff;
    padding: 12px 20px;
  }
</style>

<style scoped>
  .pure-menu-list.main-menu {
    float: right;
    margin: 5px 5px 0 0;
    font-size: 20px;
  }
  .pure-menu-list.main-menu > .pure-menu-item > a {
    cursor: default;
    color: #fff;
  }
  .pure-menu-list.main-menu .pure-menu-children {
    left: auto;
    right: 0;
    top: 46px;
    box-shadow: 0px 0px 10px -3px rgba(0,0,0,0.5);
  }
  .pure-menu-list.main-menu .pure-menu-children > .pure-menu-item {
    border-top: 1px solid #eaeaea;
  }
  .pure-menu-list.main-menu .pure-menu-children > .pure-menu-item:first-child {
    border-top-width: 0;
  }
  .pure-menu-list.main-menu .pure-menu-children .pure-menu-link {
    font-size: 16px;
    padding: 1em 1.3em;
  }
  ..pure-menu-list.main-menu .pure-menu-link {
    color: #fff;
    padding: 13px 18px;
  }
  .pure-menu-list.main-menu .pure-menu-item:hover > .pure-menu-link {
    color: #296486;
    background-color: #fff;
  }
  .pure-menu-has-children>.pure-menu-link:after {
    display: none;
  }
  /* Style the tab */
  .tab {
      float: left;
      border-right: 1px solid #ccc;
      width: 40%;
      height: 300px;
      box-sizing: border-box;
      padding-right: 30px;
  }

  /* Style the buttons that are used to open the tab content */
  .tab button {
      display: block;
      background: transparent;
      color: #aaa;
      padding: 6px 8px;
      margin: 15px 0;
      width: 100%;
      border: none;
      outline: none;
      text-align: left;
      cursor: pointer;
      transition: 0.3s;
      border-bottom: 1px solid transparent;
  }

  /* Change background color of buttons on hover */
  .tab button:hover {
    color: #666;
  }

  /* Create an active/current "tab button" class */
  .tab button.active {
    color: #222;
    border-color: #ccc;
  }

  /* Style the tab content */
  .tabcontent {
      float: left;
      padding: 0px 12px;
      width: 60%;
      border-left: none;
      height: auto;
      box-sizing: border-box;
  }
  /* Shared */
  .loginBtn {
    box-sizing: border-box;
    position: relative;
    /* width: 13em;  - apply for fixed size */
    margin: 1em auto;
    padding: 0 15px 0 46px;
    border: none;
    text-align: center;
    line-height: 34px;
    white-space: nowrap;
    border-radius: 0.2em;
    font-size: 16px;
    color: #FFF;
    display: block;
    width: 240px;
    font-family: 'PT Sans', Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
  }
  .loginBtn:before {
    content: "";
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 34px;
    height: 100%;
  }
  .loginBtn:focus {
    outline: none;
  }
  .loginBtn:active {
    box-shadow: inset 0 0 0 32px rgba(0,0,0,0.1);
  }

  /* Facebook */
  .loginBtn--facebook {
    background-color: #4C69BA;
    background-image: linear-gradient(#4C69BA, #3B55A0);
    /*font-family: "Helvetica neue", Helvetica Neue, Helvetica, Arial, sans-serif;*/
    text-shadow: 0 -1px 0 #354C8C;
  }
  .loginBtn--facebook:before {
    border-right: #364e92 1px solid;
    background: url('https://s3-us-west-2.amazonaws.com/s.cdpn.io/14082/icon_facebook.png') 4px 7px no-repeat;
  }
  .loginBtn--facebook:hover,
  .loginBtn--facebook:focus {
    background-color: #5B7BD5;
    background-image: linear-gradient(#5B7BD5, #4864B1);
  }

  /* Google */
  .loginBtn--google {
    /*font-family: "Roboto", Roboto, arial, sans-serif;*/
    background: #DD4B39;
  }
  .loginBtn--google:before {
    border-right: #BB3F30 1px solid;
    background: url('https://s3-us-west-2.amazonaws.com/s.cdpn.io/14082/icon_google.png') 4px 7px no-repeat;
  }
  .loginBtn--google:hover,
  .loginBtn--google:focus {
    background: #E74B37;
  }

  /* Grapevine */
  .loginBtn--grapevine {
    /*font-family: "Roboto", Roboto, arial, sans-serif;*/
    background: #36a731;
    margin-bottom: 30px;
  }
  .loginBtn--grapevine:before {
    border-right: #30982c 1px solid;
    content: 'G';
    width: 34px;
    text-align: center;
    font-size: 26px;
  }
/*  .loginBtn--grapevine:hover,
  .loginBtn--grapevine:focus {
    background: #E74B37;
  }*/

  #login-signup-wrap {
    width: 100%;
    margin: 30px auto;
  }
  #login-signup-wrap hr {
    display: block;
    width: 100%;
    margin: 40px 0;
  }
  #login-signup-wrap .pure-form {
    max-width: 240px;
    margin: 0 auto;
    box-sizing: border-box;
    display: block;
  }
  #login-signup-wrap .pure-form.login {
    margin-bottom: 0;
  }
  #login-signup-wrap .pure-form.sign-up {
    margin-top: 0;
  }
  #login-signup-wrap .pure-form.sign-up > h4 {
    margin-top: 0;
  }
  #login-signup-wrap .pure-form input {
    width: 100%;
    margin: 1em 0;
  }
  .grapevine-login-wrap {
    display: none;
    height: auto;
    overflow: hidden;
  }
  .notice:empty {
    display: none;
  }
  #btnLogin, #btnSignUp {
    width: 100%;
  }
  #username-select {
    margin: 46px 0;
    display: none;
  }
  form input[type=text] {
    display: inline-block;
    margin: 0;
  }
  .spacer {
    height: 30px;
    line-height: 30px;
    margin: 10px 0;
  }
  #username-select button {
    padding: 9px 14px;
    vertical-align: top;
    margin-left: 5px;
  }
  #username-select button[disabled] {
    opacity: 0.5;
  }
  .help {
    color: green;
    font-weight: bold;
  }
  .help.is-danger {
    color: red;
  }
  #account-detail-wrap {
    width: 100%;
    max-width: 1000px;
    margin: 50px auto 0;
    padding: 0 15px;
    box-sizing: border-box;
  }
  .user-details {
    text-align: left;
    margin-bottom: 30px;
    padding-left: 60px;
  }
  .user-details p span {
    font-weight: bold;
  }
  .username-set-toggle {
    margin-right: 15px;
  }
  #newsletter-prefs, #notification-prefs {
    text-align: left;
    padding-left: 60px;
    box-sizing: border-box;
  }
  #newsletter-prefs > p, #notification-prefs > p {
    margin-bottom: 2em;
  }
  .newsletter-prefs-form {
    max-width: 100%;
    text-align: left;
  }
  .newsletter-prefs-form label.pure-radio {
    display: block;
    position: relative;
    padding-left: 50px;
    margin-bottom: 20px;
    cursor: pointer;
    line-height: 34px;
  }
  .newsletter-prefs-form label.pure-radio input[type=radio], .newsletter-prefs-form label.pure-radio input[type=checkbox] {
    position: absolute;
    opacity: 0;
    cursor: pointer; 
  }
  .newsletter-prefs-form label.pure-radio .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 35px;
    width: 35px;
    background-color: #ccc;
    border: 2px solid #ccc;
    box-sizing: border-box;
  }
  .newsletter-prefs-form label.pure-radio input:checked ~ .checkmark, .newsletter-prefs-form label.pure-radio input:hover ~ .checkmark {
    background-color: #36a731;
  }
  #btnSavePrefs {
    margin-top: 20px;
    float: left;
  }
  #btnPrivacyPolicy {
    margin-top: 20px;
    margin-left: 20px;
    background: transparent;
    float: left;
    border: 1px solid #eaeaea;
  }
  .tab-back {
    opacity: 0;
    display: none;
  }
  @media only screen and (max-width: 767px) {
    #account-detail-wrap {
      position: relative;
      height: 100vh;
      overflow-y: scroll;
      width: 100%;
      margin-top: 20px;
      padding: 0;
    }
    .user-details, #newsletter-prefs, #notification-prefs {
      padding-left: 0;
    }
    #btnSavePrefs {
      padding: 10px 14px;
    }
    #btnPrivacyPolicy {
      padding: 10px 14px;
      margin-left: 10px;
    }
    .tab {
      width: 100%;
      float: none;
      border: 0;
      padding: 0 20px;
      height: 40px;
      border-bottom: 1px solid #eee;
      margin-bottom: 10px;
    }
    .tab button {
      float: left;
      display: inline-block;
      width: auto;
      padding: 0;
      height: 40px;
      line-height: 40px;
      margin: 0 12px -1px;
      color: #aaa;
    }
    .tab button:first-child {
      margin-left: 0;
    }
    .tab button.active {
      color: #222;
      border-color: #666;
    }
    .tabcontent {
      width: 100%;
      padding: 0 20px;
    }
/*    .tab button.active {
      color: #aaa;
      border-color: transparent;
    }
    .tab-back {
      text-align: right;
      margin-right: 30px;
      margin-bottom: 20px;
      opacity: 0;
      position: absolute;
      top: 0;
      right: 0;
      -webkit-transition: all 0.5s;
      -moz-transition: all 0.5s;
      -ms-transition: all 0.5s;
      -o-transition: all 0.5s;
      transition: all 0.5s;
    }
    .has-tab-active .tab-back {
      opacity: 1;
    }
    .tab {
      width: 100%;
      border-right: 0;
      padding: 0 30px;
      transform: translateX(0);
      -webkit-transition: all 0.5s;
      -moz-transition: all 0.5s;
      -ms-transition: all 0.5s;
      -o-transition: all 0.5s;
      transition: all 0.5s;
    }
    .has-tab-active .tab {
      transform: translateX(-100vw);
    }
    .tabcontent {
      transform: translateX(100vw);
      position: absolute;
      display: block!important;
      top: 39px;
      width: 100%;
      z-index: 2;
      padding: 0 30px;
      -webkit-transition: all 0.5s;
      -moz-transition: all 0.5s;
      -ms-transition: all 0.5s;
      -o-transition: all 0.5s;
      transition: all 0.5s;
    }
    .tabcontent.active {
      transform: translateX(0);
    }*/
    .user-details {
      margin-bottom: 30px;
      padding-bottom: 60px;
      border-bottom: 1px solid #eaeaea;
    }
    #username-select {
      text-align: left;
      width: 100%;
      margin: 20px 0 35px;
    }
    #username-select input {
      width: 58%;
      margin-bottom: 0;
    }
    #username-select button {
      margin-left: 3%;
      width: 37%;
      margin-top: 0;
      vertical-align: top;
    }
    #btnLogout {
      margin-left: 0;
    }
    #newsletter-prefs {
      text-align: left;
      margin-bottom: 50px;
      padding-left: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Account.vue